<template>
  <div class="pmgc_news">
    <navbar/>
    <div class="animated bounceInDown">
        <img src="../../assets/sean-kong-491810-unsplash.jpg" class="responsive-img" width="100%">
        <div class="header-text text-center center-align">
          <h4 class="center-align white-text animated slideInLeft" style="background-color: rgba(0, 0, 0, .4);text-transform: uppercase;">Our News!<br/><br/>
          PLATINUM MINDS GLOBAL COMPANY
          </h4>
        </div>
    </div>
    <div class="row">
      <div class="col s12 white">
        <div class="card">
          <div class="card-content col s12 m6">
            <p class="bold x15">"THIS IS MY SCHOOL, I MUST FIND IT", OVERALL WINNER OF PLATINUM REASONING CONTEST 2017 LAMENTED!</p>
            <br/>
            <p class="x15">
              Bankole Oluwafemi, a 200L computer science student of Redeemer's University, Nigeria badges the first position in the just conlcuded Platinum Reasoning ...
            </p>
            <div class="card-action">
              <router-link to="/news/" class="right">Read More</router-link>
            </div>
          </div>
          <div class="card-image col s12 m6">
            <img src="../../assets/news/this is my schl.png">
          </div>
        </div>
      </div>
      <div class="col s12 white">
        <div class="card">
          <div class="card-content col s12 m6">
            <p class="bold x15">
            A 16 YEAR OLD GIRL WHO MADE HER SCHOOL PROUD IN PLATINUM REASONING CONTEST SHARED HER VIEWS ON THE REASONING CONTEST.</p>
            <br/>
            <p class="x15">
              Abdulsalam Folasewa Mariam, a student of Obafemi Awolowo University,Nigeria who badged the 2nd runner up in the just concluded Platinum Reasoning ...
            </p>
            <div class="card-action">
              <router-link to="/news/" class="right">Read more</router-link>
            </div>
          </div>
          <div class="card-image col s12 m6">
            <img src="../../assets/news/16yr old girl.jpg">
          </div>
        </div>
      </div>
      <div class="col s12 white">
        <div class="card">
          <div class="card-content col s12 m6">
            <p class="bold x15">
              A REDEEMER'S UNIVERSITY STUDENT WINS N500,000 AT THE GRAND FINALE CEREMONY OF PLATINUM REASONING CONTEST.</p>
            <br/>
            <p class="x15">
              On Saturday, 18th November 2017 at Transcorp Hilton, Abuja, a 200 level Computer science student was announced the overall winner in Platinum Reasoning Contest  ...
            </p>
            <div class="card-action">
              <router-link to="/news/" class="right">Read more</router-link>
            </div>
          </div>
          <div class="card-image col s12 m6">
            <img src="../../assets/news/top three winners.jpg">
          </div>
        </div>
      </div>
    </div>
    <footer-page/>
    <router-view></router-view>
  </div>
</template>

<script>
import Navbar from '@/components/layouts/navbar'
import FooterPage from '@/components/layouts/footer-page'
export default {
  components: {Navbar, FooterPage}
}
</script>

<style>
/* div.pmgc_news > div.row > div > div > div.card-content.col.s12.m6 > div {
  margin-top: 17%;
} */
div.pmgc_news .card .card-action a:not(.btn):not(.btn-large):not(.btn-small):not(.btn-large):not(.btn-floating):hover {
    color: rgba(244, 164, 96, .7);
    text-decoration: underline;
}
div.pmgc_news > div.row > div > div > div.card-image.col.s12.m6 > img {
  height: 313.69px
}
div.pmgc_news > div.row > div {
  margin-top: 1.3%;
}
div.pmgc_news > div.row > div > div > div.card-action > a {
  margin-top: -1.5%;
}
div.pmgc_news > div.animated.bounceInDown > div > h4 {
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  padding: 1rem;
  top: 36% !important;
  left: 0px;
  right: 0px;
  font-weight: bold;
  text-transform: uppercase;
  }
</style>



// WEBPACK FOOTER //
// src/pmgc/news/index.vue